import { render } from "./CustomersForm.vue?vue&type=template&id=d1d8f668"
import script from "./CustomersForm.vue?vue&type=script&lang=js"
export * from "./CustomersForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__